import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect } from 'react'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { FetchPartnerPublicInfo, Logout } from 'src/constants/actionTypes'
import { PartnerPublicInfo } from 'src/interfaces/partner'
import { getPartner } from 'src/selectors/partner'

export const ClientSignedInPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()

  const partner = useSelector(getPartner)

  useEffect(() => {
    if (!params?.partnerName || !partner?.name) {
      return
    }

    const handleReSignUp = async () => {
      try {
        const publicPartner: PartnerPublicInfo = await createAsyncAction(
          dispatch,
          FetchPartnerPublicInfo.request({ partnerName: params?.partnerName }),
        )

        if (partner?.name === publicPartner?.name) {
          navigate(CLIENT_ROUTES.HOME_URL)

          return
        }

        await createAsyncAction(dispatch, Logout.request())

        navigate(`/client/${params.partnerName}/sign-in`)
      } catch (error) {
        navigate(CLIENT_ROUTES.HOME_URL)
      }
    }

    handleReSignUp()
  }, [params?.partnerName, partner?.name])

  if (!params?.partnerName) {
    return <Navigate to={CLIENT_ROUTES.HOME_URL} />
  }

  return null
}
